<h2>Bienvenido</h2>
<h4>Ingresa el código que te hemos enviado al correo electrónico</h4>

<button type="submit" class="outline-btn outline-btn-white" (click)="goToCotizacion()">Ver cotización</button>